<template>
    <div>
      <input 
        type="number" 
        v-model="mtbf" 
        class="form-control" 
        :min="0" 
        :max="20000"
        @input="formatNumber"
      >
    </div>
  </template>
  
  <script>
  export default {
    name: 'FieldMTBF',
    props: {
      value: Number
    },
    data() {
      return {
        mtbf: this.value
      };
    },
    watch: {
      value(newVal) {
        this.mtbf = newVal;
      },
      mtbf(newVal) {
        this.$emit('input', newVal);
      }
    },
    methods: {
      formatNumber() {
        this.mtbf = Number(this.mtbf).toLocaleString();
      }
    }
  }
  </script>
  